import {UsuarioPesquisa, Escopos, VincularEscopos, Escopo, UsuarioRetorno} from './../../../model/usuario';
import {GlobalService} from './../../../service/global.service';
import {FormControl, FormGroup} from '@angular/forms';
import {Component, OnInit, HostListener} from '@angular/core';
import {IMyDpOptions} from 'mydatepicker';
import {HttpClient} from '@angular/common/http';
import {JQueryStatic} from 'jquery';
import {Router, ActivatedRoute} from '@angular/router';
import {SelectItem, MessageService} from 'primeng/api';
import {UtilApi} from '../../../service/api/util.api';
import {UserAplicacao, Cliente} from './../../../model/catalogo';
import {FiltroCliente} from './../../../model/filtros';
import {PesquisasFiltroApiService} from './../../../service/api/pesquisas-filtro.api';

declare var $: JQueryStatic;

@Component({
    selector: 'app-usuario-novo',
    templateUrl: './usuario-novo.component.html',
    styleUrls: ['./usuario-novo.component.css']
})

export class UsuarioNovoComponent implements OnInit {

    constructor(
        public http: HttpClient,
        public globalService: GlobalService,
        private router: Router,
        private route: ActivatedRoute,
        private utilApi: UtilApi,
        private messageService: MessageService,
        private pesquisaService: PesquisasFiltroApiService
    ) {
    }


    @HostListener('window:keyup', ['$event'])
    keyEvent(event: KeyboardEvent) {
        if (event != null) {
            if (event.keyCode === 13) {
                if (this.userform.valid == true && this.usuarioRetorno == null) {
                    this.salvarUsuario();
                }
            }
        }
    }


    tituloPagina: string = 'Cadastrar Usuário';


    hoje: Date = new Date();
    codUsuario: string = '0';
    versaoUsuario: string = '0';
    usuarioUpdate: UsuarioPesquisa = new UsuarioPesquisa();
    escopos: Array<Escopos> = new Array<Escopos>();
    escoposLabel: SelectItem[];
    selectedScopos: number[] = [];
    vincularEscopos: VincularEscopos = new VincularEscopos();
    usuarioRetorno: UsuarioRetorno = new UsuarioRetorno();
    userform: FormGroup;
    mensagens = [];
    controleBotaoAjuda = false;

    ngOnInit() {
        this.utilApi.invocacaoRemotaComRetry(5, 1000, this, UsuarioNovoComponent.prototype.carregarConstantes);
        this.userform = new FormGroup({
            nome: new FormControl('', []),
            descricao: new FormControl('', []),
            certificado: new FormControl('', []),

            qtd_alarme_sia: new FormControl('', []),
            alarme_sia: new FormControl('', []),
            dtConexao: new FormControl('', []),
            uor: new FormControl('', []),
            mci: new FormControl('', []),
            observacaoAlteracao: new FormControl('', []),
            senha: new FormControl('', []),
            escopos: new FormControl('', []),
        });
        this.escoposLabel = [];
        this.route.params.subscribe(params => {
            this.codUsuario = params['codigo'];
            this.versaoUsuario = params['versao'];

            if (this.codUsuario != undefined) {
                this.tituloPagina = 'Editar Usuário';
                this.getUsuario();

            } else {
                this.codUsuario = '0';
                this.versaoUsuario = '0';
            }

            this.carregarMensagensAjuda();

        });


    }

    public myDatePickerOptions: IMyDpOptions = {
        dateFormat: 'dd/mm/yyyy',
        monthLabels: {
            1: 'Jan',
            2: 'Fev',
            3: 'Mar',
            4: 'Abr',
            5: 'Mai',
            6: 'Jun',
            7: 'Jul',
            8: 'Ago',
            9: 'Set',
            10: 'Out',
            11: 'Nov',
            12: 'Dez'
        },
        dayLabels: {su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab'},
        sunHighlight: true,
        satHighlight: true,
        editableDateField: true,
        todayBtnTxt: 'Hoje',
        firstDayOfWeek: 'su',
        maxYear: this.hoje.getFullYear(),
        openSelectorOnInputClick: true
    };

    getUsuario() {
        let url = this.globalService.getConfiguracao().api_autorizador + '/usuario/' + this.codUsuario + '/' + this.versaoUsuario;

        this.http.get(url, {headers: {'Content-Type': 'application/json; charset=utf-8'}}).toPromise()
            .then(
                response => {
                    this.globalService.loading = false;
                    this.usuarioUpdate = response as UsuarioPesquisa;
                    this.preencherUsuarioForm();

                    this.usuarioUpdate.escopos.forEach(obj => {
                        this.selectedScopos.push(parseInt(obj.codEscopo));
                    });
                }
            ).catch(
            error => {
                this.exibirMensagemErro(error);
                this.globalService.loading = false;
            }
        );
    }

    salvarUsuario() {
        let usuario = this.validarUsuario();
        let url = this.globalService.getConfiguracao().api_autorizador + '/usuario/' + this.codUsuario + '/' + this.versaoUsuario;
        let data = JSON.stringify(usuario);

        // this.atribuirScopos(this.selectedScopos);

        //this.validaUsuarioNovo("username", usuario["username"],function(){
        this.http.put(url, data, {headers: {'Content-Type': 'application/json; charset=utf-8'}}).toPromise()
            .then(
                response => {
                    this.usuarioRetorno = response as UsuarioRetorno;
                    if (this.selectedScopos.length > 0) {
                        this.atribuirScopos(this.usuarioRetorno.codigo, this.usuarioRetorno.versao, this.selectedScopos);
                    }
                    this.globalService.loading = false;
                    if (this.codUsuario != '0') {
                        this.exibirMensagemSucesso('Usuário atualizado com sucesso!');
                    } else {
                        this.exibirMensagemSucesso('Usuário cadastrado com sucesso!');
                    }
                }
            ).catch(
            error => {
                this.exibirMensagemErro(error);
                this.globalService.loading = false;
            }
        );
        //}.bind(this));

        /**/
    }

    preencherUsuarioForm() {
        this.userform.get('nome').setValue(this.usuarioUpdate.username);
        this.userform.get('descricao').setValue(this.usuarioUpdate.descricao);
        this.userform.get('certificado').setValue(this.usuarioUpdate.nomeCertificadoVinculado);
        // this.matricula.setValue(this.usuarioUpdate.)
        this.userform.get('qtd_alarme_sia').setValue(this.usuarioUpdate.qtdMinGeracaoAlarmeSia);
        this.userform.get('alarme_sia').setValue(this.usuarioUpdate.msgAlarmeSia);
        this.userform.get('dtConexao').setValue(this.usuarioUpdate.timeStampUltConexaoSia);
        this.userform.get('uor').setValue(this.usuarioUpdate.codUorVinc);
        this.userform.get('mci').setValue(this.usuarioUpdate.codMciVinc);
        this.userform.get('observacaoAlteracao').setValue(this.usuarioUpdate.obsAlteracao);
        this.userform.get('senha').setValue(this.usuarioUpdate.senha);
    }

    validarUsuario(): UsuarioPesquisa {

        let usuarioPesquisa: UsuarioPesquisa = new UsuarioPesquisa();

        if (this.userform.get('nome').value != '') {
            usuarioPesquisa.username = this.userform.get('nome').value;
        }


        if (this.userform.get('certificado').value != '') {
            usuarioPesquisa.nomeCertificadoVinculado = this.userform.get('certificado').value;
        }

        if (this.userform.get('uor').value != '') {
            usuarioPesquisa.codUorVinc = this.userform.get('uor').value;
        }

        if (this.userform.get('mci').value != '') {
            usuarioPesquisa.codMciVinc = this.userform.get('mci').value;
        }

        if (this.userform.get('alarme_sia').value != '') {
            usuarioPesquisa.msgAlarmeSia = this.userform.get('alarme_sia').value;
        }

        if (this.userform.get('qtd_alarme_sia').value != '') {
            usuarioPesquisa.qtdMinGeracaoAlarmeSia = this.userform.get('qtd_alarme_sia').value;
        }

        if (this.userform.get('descricao').value != '') {
            usuarioPesquisa.descricao = this.userform.get('descricao').value;
        }

        // if (this.dtConexao.value != "") {
        //   usuarioPesquisa.timeStampUltConexaoSia = this.dtConexao.value;
        // }

        usuarioPesquisa.obsAlteracao = 'Criação do usuário via interface de administração';

        if (this.userform.get('senha').value != '') {
            usuarioPesquisa.senha = this.userform.get('senha').value;
        }

        return usuarioPesquisa;

    }

    exibirMensagemSucesso(msgTxt: string) {
        $.confirm({
            title: 'Sucesso!',
            content: msgTxt,
            type: 'green',
            buttons: {
                ok: {
                    btnClass: 'btn-blue'
                }
            },
            onClose: () => {
                this.router.navigate(['/usuario']);
            }
        });
    }

    exibirMensagemErro(msgTxt: string) {
        $.confirm({
            title: 'Erro!',
            content: msgTxt,
            type: 'red',
            buttons: {
                ok: {
                    btnClass: 'btn-blue'
                }
            }
        });
    }

    cancelar() {
        this.router.navigate(['/usuario']);
    }

    getEscopos() {
        let url = this.globalService.getConfiguracao().api_autorizador + '/usuario/escopo';

        this.http.get(url, {headers: {'Content-Type': 'application/json; charset=utf-8'}}).toPromise()
            .then(
                response => {
                    this.escopos = response as Escopos[];
                    this.escopos.forEach(obj => {
                        this.escoposLabel.push({label: obj.nmEscopo, value: obj.codEscopo});
                    });

                }
            ).catch(
            error => {
                // this.exibirMensagemErro(error)
            }
        );
    }

    atribuirScopos(codigo: number, versao: number, selectedScopos: number[]) {

        let url = this.globalService.getConfiguracao().api_autorizador + '/usuario/vincularEscopos';
        this.vincularEscopos.codUsuario = codigo;
        this.vincularEscopos.vrsUsuario = versao;
        selectedScopos.forEach(obj => {
            let escopo = new Escopo();
            escopo.codEscopo = obj;
            this.vincularEscopos.escopos.push(escopo);
        });


        let data = JSON.stringify(this.vincularEscopos);
        this.http.put(url, data, {headers: {'Content-Type': 'application/json; charset=utf-8'}}).toPromise()
            .then(
                () => {
                }
            ).catch(
            error => {
                this.exibirMensagemErro(error);
                this.globalService.loading = false;
            }
        );
    }

    carregarConstantes() {
        this.getEscopos();

    }

    carregarMensagensAjuda() {
        this.mensagens['nome'] = 'Informe o username para o usuário impessoal.';
        this.mensagens['descricao'] = 'Descrição curta sobre o usuário.';
        this.mensagens['certificado'] = 'Preencher SOMENTE se o cliente for se autenticar mediante certificado digital E o common name de seu certificado é diferente do username.';
        this.mensagens['mensagemSia'] = ' Preencha somente se desejar monitorar uso do SIA CLIENT pelo cliente, informe a mensagem que deve ser alarmada.';
        this.mensagens['qtdMinimo'] = ' Preencha somente se desejar monitorar uso do SIA CLIENT do cliente. Informe quantos minutos o SIA CLIENT do cliente deve estar inativo para ser gerado alarme.';
        this.mensagens['UOR'] = ' Informe UOR SOMENTE se o usuário estiver vinculado a uma UOR (ou seja, é um usuário impessoal de uma UOR).';
        this.mensagens['MCI'] = ' Informe MCI SOMENTE se o usuário estiver vinculado a um MCI (ou seja, é um usuário impessoal de um MCI).';
        this.mensagens['escopos'] = 'Seleciona as permissões que o usuário terá.';
        this.mensagens['senha'] = ' Informe a senha inicial do usuário..';
    }

    clearMsgAjuda() {
        this.messageService.clear();
    }

    msgAjuda(campo: string) {
        this.clearMsgAjuda();
        this.messageService.add({
            severity: 'info',
            sticky: true,
            closable: false,
            summary: 'Ajuda',
            detail: this.mensagens[campo]
        });


    }

}



// WEBPACK FOOTER //
// ./src/app/usuario/usuario-novo/usuario-novo.component.ts